import { render, staticRenderFns } from "./BdrAnswerEmails.vue?vue&type=template&id=58a2b4ec"
import script from "./BdrAnswerEmails.vue?vue&type=script&lang=js"
export * from "./BdrAnswerEmails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports